import React from 'react';
import { NotificationPreferencesCard } from '@/components/notifications/NotificationPreferencesCard';
import { NotificationDebugPanel } from '@/components/notifications/NotificationDebugPanel';

export function NotificationsTab() {
  return (
    <div className="grid gap-4 sm:gap-6">
      {/* Notification Preferences */}
      <NotificationPreferencesCard />

      {/* Debug Panel */}
      <NotificationDebugPanel />
    </div>
  );
}
